module.exports = __webpack_public_path__ + "static/media/ANKR.831c8676.svg";